export default __webpack_public_path__ + "static/media/banner-x-horizon.9056e3df.png";